export function CommoHuanEchartOp () {
  let option = {
    tooltip: {
      trigger: 'item'
    },
    color: [
      {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: 'rgba(13, 38, 246, 1)' // 0% 处的颜色
        }, {
          offset: 1, color: 'rgba(50, 248, 253, 1)' // 100% 处的颜色
        }]
      }
    ],
    polar: {
      // 4-130 3-160  2-280
      radius: ['0%', '130%']
    },
    angleAxis: {
      max: 0,
      startAngle: 90,
      axisLine: {
        show: false
      },
      minorSplitLine: {
        show: false
      },
      splitLine: {
        show: false
      },
      axisLabel: {
        show: false
      },
      axisTick: {
        show: false
      }
    },
    radiusAxis: {
      type: 'category',
      max: 4,
      // data: [
      //   '连续包月(续费)',
      //   '单点',
      //   '普通包月',
      //   '连续包月(购买)',
      //   '包年'
      // ],
      data: [],
      minInterval: 15,
      splitNumber: 15,
      axisLabel: {
        color: 'rgba(0, 0, 0, 0.6)',
        fontSize: 12,
        show: true,
        interval: 0// 不隐藏label
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      // boundaryGap: ['20%', '25%'],
      zlevel: 10
    },
    series: {
      type: 'bar',
      roundCap: true,
      data: [],
      coordinateSystem: 'polar',
      label: {
        show: false,
        position: 'right',
        formatter: '{b}',
        color: 'red'
      },
      showBackground: true,
      backgroundStyle: {
        color: '#fff'
      },
      // barWidth: v.fontSizeRem(0.3),
      // barCategoryGap: '50%',
      barWidth: 8
    }
  }

  return option
}
export function CRevenueEchartOp ({ v, data }) {
  let option = CommoHuanEchartOp()
  option.angleAxis.max = data.max
  option.radiusAxis.data = [...(data.nameLabel ?? data.name ?? [])]
  option.series.data = [...data.data]
  switch (data.data.length) {
    case 2:
      option.polar.radius = ['100%', '30%']
      break
    case 3:
      option.polar.radius = ['100%', '30%']
      break
    case 4:
      option.polar.radius = ['100%', '30%']
      break
  }
  console.log(option.polar.radius)
  return option
}
export function CNetProfitEchartOp ({ v, data }) {
  let option = CommoHuanEchartOp()
  option.angleAxis.max = data.max
  option.radiusAxis.data = [...(data.nameLabel ?? data.name ?? [])]
  option.series.data = [...data.data]
  return option
}
export function CExperienceIndicators ({ v, data }) {
  let option = CommoHuanEchartOp()
  option.angleAxis.max = data.max
  option.radiusAxis.data = [...(data.nameLabel ?? data.name ?? [])]
  option.series.data = [...data.data]
  return option
}

export function CProductEchart ({ v, data }) {
  let option = {
    color: [
      {
        type: 'linear',
        x: 1,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: 'rgba(243, 37, 122, 1)' // 0% 处的颜色
        }, {
          offset: 1, color: 'rgba(255, 116, 178, 1)' // 100% 处的颜色
        }]
      },
      {
        type: 'linear',
        x: 1,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: 'rgba(250, 139, 39, 1)' // 0% 处的颜色
        }, {
          offset: 1, color: 'rgba(255, 230, 101, 1)' // 100% 处的颜色
        }]
      },
      {
        type: 'linear',
        x: 1,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: 'rgba(0, 245, 194, 1)' // 0% 处的颜色
        }, {
          offset: 1, color: 'rgba(0, 182, 211, 1)' // 100% 处的颜色
        }]
      },
      {
        type: 'linear',
        x: 1,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: 'rgba(4, 94, 226, 1)' // 0% 处的颜色
        }, {
          offset: 1, color: 'rgba(0, 176, 255, 1)' // 100% 处的颜色
        }]
      }
    ],
    grid: {
      left: '5%',
      top: '10%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    legend: {
      icon: 'circle',
      right: 0,
      left: 0,
      itemGap: 2,
      itemWidth: 8,
      itemHeight: 8,
      data: ['会员收入', '流量收入', '软件收入', '硬件收入'],
      textStyle: {
        color: 'rgba(0, 0, 0, 0.8)'
      }
    },
    series: [
      {
        name: '访问来源',
        type: 'pie',
        radius: ['0%', '100%'],
        avoidLabelOverlap: false,
        top: '20%',
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '30',
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: [
          { value: 335, name: '会员收入' },
          { value: 310, name: '流量收入' },
          { value: 234, name: '软件收入' },
          { value: 135, name: '硬件收入' }
        ]
      }
    ]
  }
  return option
}

export function UserRateIndexEchartOp ({ v, data }) {
  let option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    color: [
      {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: 'rgba(53, 255, 255, 1)' // 0% 处的颜色
        }, {
          offset: 1, color: 'rgba(11, 32, 245, 1)' // 100% 处的颜色
        }]
      }
    ],
    grid: {
      left: '0%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        name: '测试1',
        type: 'bar',
        data: [
          { value: 26620, percent: 0, name: '点击', label: { show: false } },
          { value: 19242, percent: 72.8, name: '访问' },
          { value: 19242, percent: 100, name: '咨询' },
          { value: 19182, percent: 99.69, name: '订单' }
        ],
        label: {
          show: false,
          position: 'right',
          formatter: '{b}'
        },
        backgroundStyle: {
          color: '#fff'
        }
        // barWidth: v.fontSizeRem(0.3),
      },
      {
        name: '测试2',
        type: 'bar',
        data: [
          { value: 26620, percent: 0, name: '点击', label: { show: false } },
          { value: 19242, percent: 72.8, name: '访问' },
          { value: 19242, percent: 100, name: '咨询' },
          { value: 19182, percent: 99.69, name: '订单' }
        ],
        label: {
          show: false,
          position: 'right',
          formatter: '{b}'
        },
        backgroundStyle: {
          color: '#fff'
        }
        // barWidth: v.fontSizeRem(0.3),
      },
      {
        name: '测试3',
        type: 'bar',
        data: [
          { value: 26620, percent: 0, name: '点击', label: { show: false } },
          { value: 19242, percent: 72.8, name: '访问' },
          { value: 19242, percent: 100, name: '咨询' },
          { value: 19182, percent: 99.69, name: '订单' }
        ],
        label: {
          show: false,
          position: 'right',
          formatter: '{b}'
        },
        backgroundStyle: {
          color: '#fff'
        }
        // barWidth: v.fontSizeRem(0.3),
      },
      {
        name: '测试4',
        type: 'bar',
        data: [
          { value: 26620, percent: 0, name: '点击', label: { show: false } },
          { value: 19242, percent: 72.8, name: '访问' },
          { value: 19242, percent: 100, name: '咨询' },
          { value: 19182, percent: 99.69, name: '订单' }
        ],
        label: {
          show: false,
          position: 'right',
          formatter: '{b}'
        },
        backgroundStyle: {
          color: '#fff'
        }
        // barWidth: v.fontSizeRem(0.3),
      }
    ]
  }

  return option
}
